$(document).ready(function() {
  // Initialize datepickers on initial variant rows
  $('.datepicker, #datepicker, .input-group.date').bootstrapDP({
    autoclose: true,
    format: "dd/mm/yyyy",
    todayHighlight: true,
    orientation: "bottom",
    language: I18n.locale
  });

  // $('table#variant-table').on('click', '.remove-variant', function() {
  //   var elTr = $(this).parents('tr');
  //   var elTody = elTr.parents('tbody');

  //   // REMOVE TR ELEMENT
  //   elTr.remove();
  //   if (elTody.find('tr').length == 1) {
  //     var lastTr = elTody.find('tr')

  //     // REMOVE BUTTON FOR LAST VARIANT
  //     lastTr.find('button.remove-variant').remove()
  //   }
  // })

  $('table#variant-table').on('click', '.destroy-variant', function() {
    var elTr = $(this).parents('tr');
    var _destroy = elTr.find('input._destroy_variant');
    var hasStockId = elTr.find('input[name*="[inventory_stock_attributes][id]"]').length > 0;

    if (!hasStockId) {
      // Unsaved row: remove completely to avoid required-field validation
      elTr.remove();
    } else {
      // Existing row: mark for destroy and disable required fields to prevent browser validation
      _destroy.val(true)
      elTr.addClass('d-none')
      elTr.find('input, select, textarea').each(function() {
        if (!$(this).hasClass('_destroy_variant')) {
          $(this).prop('required', false);
        }
      })

      if (elTr.parents('tbody').find('tr:not(.d-none)').length == 1) {
        var lastTr = elTr.parents('tbody').find('tr:not(.d-none)')

        // DISABLED BUTTON FOR LAST VARIANT
        lastTr.find('button.destroy-variant').attr('disabled', true)
        lastTr.find('button.destroy-variant').attr('data-tooltip', 'tooltip')
        lastTr.find('button.destroy-variant').attr('data-placement', 'top')
        lastTr.find('button.destroy-variant').attr('title', I18n.t('global.alerts.you_cant_remove_default_or_last_variant'))
      }
    }
  })

  // DEAFULT CANNOT COMBINE WITH CUSTOM VARIANT
  $('.variant-checkbox.default-v').on('change', function() {
    if ($(this).prop('checked')) {
      $('.variant-checkbox.custom-v').prop('checked', false)
      $('.variant-checkbox.default-v').attr('disabled', true)
    }
  })

  $('.variant-checkbox.custom-v').on('change', function() {
    $('.variant-checkbox.default-v').removeAttr('disabled')

    if ($(this).prop('checked')) {
      $('.variant-checkbox.default-v').prop('checked', false)
    } else {
      if ($('.variant-checkbox.custom-v:checked').length == 0) {
        $('.variant-checkbox.default-v').prop('checked', false)
        $('.variant-checkbox.default-v').attr('disabled', true)
      }
    }
  })
  // DEAFULT CANNOT COMBINE WITH CUSTOM VARIANT -- END CODE

  $('#add-variant-row').on('click', function() {
    var button       = $(this);
    var table        = $('#variant-table');
    var nextIndex    = parseInt(button.data('next-index')) || table.find('tbody tr').length;
    var adminId      = button.data('admin-id');
    var inventoryId  = button.data('inventory-id');
    var newRow       = buildVariantRow(nextIndex, adminId, inventoryId);

    table.find('tbody').append(newRow);

    // Initialize datepickers for the newly added row
    newRow.find('.datepicker').bootstrapDP({
      autoclose: true,
      format: "dd/mm/yyyy",
      todayHighlight: true,
      orientation: "bottom",
      language: I18n.locale
    });

    button.data('next-index', nextIndex + 1);
  });
})

function buildVariantRow(idx, adminId, inventoryId) {
  var row = $('<tr class="new-variant-row"></tr>');

  var labelTd = $('<td></td>').append(
    $('<input>', {
      type: 'text',
      class: 'form-control',
      name: 'inventory[variants_attributes][' + idx + '][label_name]',
      required: true
    })
  );

  var qtyTd = $('<td></td>').append(
    $('<input>', {
      type: 'number',
      class: 'form-control',
      name: 'inventory[variants_attributes][' + idx + '][inventory_stock_attributes][quantity]',
      min: 0,
      required: true
    })
  );

  var updateQtyTd = $('<td><span class="update-qty-text"></span></td>');

  var weightTd = $('<td></td>').append(
    $('<input>', {
      type: 'number',
      class: 'form-control',
      name: 'inventory[variants_attributes][' + idx + '][inventory_stock_attributes][weight]',
      min: 0,
      step: 'any',
      required: true,
      value: '0.0'
    })
  );

  var priceTd = $('<td></td>').append(
    $('<input>', {
      type: 'number',
      class: 'form-control',
      name: 'inventory[variants_attributes][' + idx + '][inventory_stock_attributes][price]',
      min: 0,
      step: 'any',
      required: true,
      value: '0.0'
    })
  );

  var productCostTd = $('<td></td>').append(
    $('<input>', {
      type: 'number',
      class: 'form-control',
      name: 'inventory[variants_attributes][' + idx + '][inventory_stock_attributes][product_cost]',
      min: 0,
      step: 'any',
      value: '0.0'
    })
  );

  var salePriceTd = $('<td></td>').append(
    $('<input>', {
      type: 'number',
      class: 'form-control',
      name: 'inventory[variants_attributes][' + idx + '][inventory_stock_attributes][sale_price]',
      min: 0,
      step: 'any',
      value: '0.0'
    })
  );

  var saleStartTd = $('<td></td>').append(
    $('<input>', {
      type: 'text',
      class: 'form-control datepicker',
      name: 'inventory[variants_attributes][' + idx + '][inventory_stock_attributes][sale_start]'
    })
  );

  var saleEndTd = $('<td></td>').append(
    $('<input>', {
      type: 'text',
      class: 'form-control datepicker',
      name: 'inventory[variants_attributes][' + idx + '][inventory_stock_attributes][sale_end]'
    })
  );

  var plusMinusTd = $('<td></td>');

  var actionTd = $('<td></td>');
  actionTd.append(
    $('<input>', {
      type: 'hidden',
      name: 'inventory[variants_attributes][' + idx + '][_destroy]',
      class: '_destroy_variant',
      value: false
    }),
    $('<input>', {
      type: 'hidden',
      name: 'inventory[variants_attributes][' + idx + '][inventory_stock_attributes][admin_id]',
      value: adminId
    }),
    $('<input>', {
      type: 'hidden',
      name: 'inventory[variants_attributes][' + idx + '][inventory_stock_attributes][inventory_id]',
      value: inventoryId
    }),
    $('<button>', {
      type: 'button',
      class: 'btn btn-secondary destroy-variant',
      text: 'Remove'
    })
  );

  row.append(labelTd, qtyTd, updateQtyTd, weightTd, priceTd, productCostTd, salePriceTd, saleStartTd, saleEndTd, plusMinusTd, actionTd);
  return row;
}
